(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function initSiteHeader(header) {
    if (header.dataset.menuReady === 'true') return;
    header.dataset.menuReady = 'true';

    const button = header.querySelector('[data-menu-toggle]');
    const menu = header.querySelector('[data-mobile-menu]');
    if (!button || !menu) return;

    function setOpen(isOpen) {
      button.setAttribute('aria-expanded', String(isOpen));
      button.setAttribute('aria-label', isOpen ? button.dataset.labelClose : button.dataset.labelOpen);
      menu.hidden = !isOpen;

      if (isOpen) {
        const firstItem = menu.querySelector('a, summary');
        if (firstItem) firstItem.focus();
      }
    }

    button.addEventListener('click', function () {
      setOpen(button.getAttribute('aria-expanded') !== 'true');
    });

    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (button.getAttribute('aria-expanded') !== 'true') return;
      setOpen(false);
      button.focus();
    });
  }

  document.querySelectorAll('[data-site-header]').forEach(initSiteHeader);

  } catch(e) { console.error(e); }
})();
})();
